export const STATUS_CONFIG: Record<
  string,
  { text: string; className: string }
> = {
  // ===== Clinical Context =====
  CC_SCHEDULED: {
    text: "Clinical Examination - Scheduled",
    className: "bg-blue-100 text-primary",
  },
  CC_RESCHEDULED: {
    text: "Clinical Examination - Re-Scheduled",
    className: "bg-blue-100 text-primary",
  },
  CC_CANCELLED: {
    text: "Clinical Examination - Cancelled",
    className: "bg-[#FDECEC] text-[#C62828]",
  },
  CC_IN_SESSION: {
    text: "Clinical Examination - In Progress",
    className: "bg-[#FFF4E5] text-[#E37400]",
  },
  CC_COMPLETED: {
    text: "Clinical Examination - Completed",
    className: "bg-[#E6F4EA] text-[#34A853]",
  },

  // ===== Screening =====
  SCR_REQUIRED: {
    text: "Screening - Required",
    className: "bg-yellow-100 text-yellow-700",
  },
  SCR_NOT_REQUIRED: {
    text: "Screening - Not Required",
    className: "bg-gray-100 text-gray-600",
  },
  SCR_SCHEDULED: {
    text: "Screening - Scheduled",
    className: "bg-blue-100 text-primary",
  },
  SCR_RESCHEDULED: {
    text: "Screening - Re-Scheduled",
    className: "bg-blue-100 text-primary",
  },
  SCR_CANCELLED: {
    text: "Screening - Cancelled",
    className: "bg-[#FDECEC] text-[#C62828]",
  },
  SCR_IN_PROGRESS: {
    text: "Screening - In Progress",
    className: "bg-[#FFF4E5] text-[#E37400]",
  },
  SCR_COMPLETED: {
    text: "Screening - Completed",
    className: "bg-[#E6F4EA] text-[#34A853]",
  },
  SCR_UPLOADING_TEST_DATA: {
    text: "Screening - Uploading Data",
    className: "bg-yellow-100 text-yellow-700",
  },
  SCR_UPLOAD_FAILED: {
    text: "Screening - Upload Failed",
    className: "bg-red-100 text-red-600",
  },
  SCR_DROPPED: {
    text: "Screening - Dropped",
    className: "bg-gray-100 text-gray-600",
  },
  SCR_DISCARDED: {
    text: "Screening - Discarded",
    className: "bg-gray-100 text-gray-600",
  },
  SCR_YET_TO_GENERATE_REPORT: {
    text: "Report - Pending",
    className: "bg-yellow-100 text-yellow-700",
  },
  // Alias used by some endpoints (e.g. Needs Action) for the same state.
  SCR_REPORT_PENDING: {
    text: "Report - Pending",
    className: "bg-yellow-100 text-yellow-700",
  },
  SCR_GENERATING_REPORT: {
    text: "Report - Generation In-queue",
    className: "bg-blue-100 text-primary",
  },
  SCR_REPORT_GENERATED: {
    text: "Report - Generated",
    className: "bg-blue-100 text-primary",
  },
  SCR_REPORT_GENERATION_FAILED: {
    text: "Report - Generation failed",
    className: "bg-red-100 text-red-600",
  },

  // ===== Report Review =====
  RR_SCHEDULED: {
    text: "Report Review - Scheduled",
    className: "bg-blue-100 text-primary",
  },
  RR_RESCHEDULED: {
    text: "Report Review - Re-Scheduled",
    className: "bg-blue-100 text-primary",
  },
  RR_CANCELLED: {
    text: "Report Review - Cancelled",
    className: "bg-[#FDECEC] text-[#C62828]",
  },
  RR_IN_PROGRESS: {
    text: "Report Review - In Progress",
    className: "bg-[#FFF4E5] text-[#E37400]",
  },
  RR_COMPLETED: {
    text: "Report Review - Completed",
    className: "bg-[#E6F4EA] text-[#34A853]",
  },
};

export const HIDE_CLINICAL_EXAM_STATUSES = new Set([
  "SCR_NOT_REQUIRED",
  "SCR_CANCELLED",
  "RR_COMPLETED",
  "RR_CANCELLED",
  "CC_CANCELLED",
]);

export const DISABLE_ACTION_STATUSES = new Set([
  "CC_IN_SESSION",
  "SCR_IN_PROGRESS",
  "RR_IN_PROGRESS",
]);

/** Screening ended without retake — portal shows Create New Assessment instead. */
export const NON_RETAKE_SCREENING_STATUSES = new Set([
  "SCR_DROPPED",
  "SCR_DISCARDED",
  "SCR_UPLOAD_FAILED",
]);

/** Matches backend INACTIVE_ASSESSMENT_STATUSES — no ongoing assessment; create new row. */
export const CREATE_NEW_ASSESSMENT_STATUSES = new Set([
  "RR_COMPLETED",
  ...NON_RETAKE_SCREENING_STATUSES,
]);
